import React from 'react';
import PropTypes from 'prop-types';

/**
 * PageHeader - Simple header component for page titles and subtitles
 */
const PageHeader = ({ title, subtitle }) => {
  return (
    <div className="mb-4">
      {title && <h4 className="mb-1">{title}</h4>}
      {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default PageHeader;

